import axios from 'axios'
import { setInterceptors } from './interceptors'

const config = {
//  baseUrl: 'http://test59.koreaapp.kr:5420',
  baseUrl:
    window.location.protocol === 'http:'      
      ? window.location.protocol + '//' + window.location.hostname + ':5413'
      //? window.location.protocol + '//' + 'wallet.coincoffee.kr' + ':5413'
      : 'https://api.plapay.io',
  // // ethGasUrl: 'https://ethgasstation.info/json/ethgasAPI.json'
  ethGasUrl:'https://api.etherscan.io/api?module=gastracker&action=gasoracle&apikey=ZXVQXFBKW3CPA4YUMRF12IX31JSG5H7W58'
}

const createInstanceWithAuth = () => {
  const instance = axios.create({
    baseURL: config.baseUrl,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json; charset = utf-8'
    }
  })
  return setInterceptors(instance)
}
const instanceWithAuth = createInstanceWithAuth()

const createInstance = () => {
  return axios.create({
    baseURL: config.baseUrl,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json; charset = utf-8'
    }
  })
}
const instance = createInstance()

const getGas = () => axios.get(config.ethGasUrl)
const getTxHistoryEth = (walletAddress, page) => {
  return axios.post(
    `https://api.etherscan.io/api?module=account&action=txlist&address=${walletAddress}&startblock=0&endblock=99999999&sort=desc&page=${page}&offset=5&apikey=B5KCQR4DWB92PC3MJ9SDV78W77E2WDR5UF`
  )
}
const getTxHistoryErc = (walletAddress, page) => {
  return axios.post(
    `https://api.etherscan.io/api?module=account&action=tokentx&address=${walletAddress}&startblock=0&endblock=99999999&sort=desc&page=${page}&offset=5&apikey=B5KCQR4DWB92PC3MJ9SDV78W77E2WDR5UF`
  )
}

const wallet_send = (params) => instanceWithAuth.post(`/wallet/send`, params)
const api_config = (params) => instanceWithAuth.post(`/api/config`, params)
const user_swap = (params) => instanceWithAuth.post(`/user/swap`, params)
const user_lockup_list = () => instanceWithAuth.post(`/user/lockup/list`)
// const api_staking = () => instanceWithAuth.post('/api/staking')
const api_staking = () => instanceWithAuth.post('/api/staking2')
const available_token = (params) =>
  instanceWithAuth.post('/api/available/token', params)

const check_address = (params) =>
  instanceWithAuth.post('/wallet/check/address', params)

const w_l_contents = (params) => instanceWithAuth.post(`/api/w_l_contents` , { params: params } )

const my_l_attend = (params) =>
  instanceWithAuth.get('/my_l_attend', { params: params })
const my_l_recommend = (params) =>
  instanceWithAuth.get('/my_l_recommend', { params: params })
// const my_point_history = (params) =>
// instanceWithAuth.get('/my_point_history', { params: params })
const my_point_history = (params) =>
  instanceWithAuth.get('/use_history', { params: params })
const w_r_my_point = () => instanceWithAuth.get('/w_r_my_point')
const balance_pli = () => instanceWithAuth.get('/wallet/balance/pli')
const exchange_pli = (params) =>
  instanceWithAuth.post('/wallet/exchange/pli', params)
const lotto_price = () => instance.get('/lotto/price')
const send_transaction = (params) =>
  instanceWithAuth.post('/wallet/send_transaction', params)
const send_transaction_tron = (params) =>
  instanceWithAuth.post('/wallet/send_transaction_tron', params)
const send_transaction_w3p = (params) =>
  instanceWithAuth.post('/wallet/send_transaction_w3p', params) 
  
const balance_all = () => instanceWithAuth.get('/wallet/balance/all')
const w_l_popup = () => instanceWithAuth.post(`/api/w_l_popup`)
const user_attend = () => instanceWithAuth.post(`/user/attend`)
const staking_token = (params) =>
  instanceWithAuth.post(`/wallet/staking/token`, params)
const psite = () => instance.post('/psite')
const event_add = () => instanceWithAuth.post('/evt/added')
const market_payed = (params) => instanceWithAuth.post('/v1/market' , params)

export {
  instance,
  instanceWithAuth,
  getGas,
  getTxHistoryErc,
  getTxHistoryEth,
  wallet_send,
  w_l_contents,
  api_config,
  user_swap,
  user_lockup_list,
  api_staking,
  available_token,
  check_address,
  my_l_attend,
  my_l_recommend,
  my_point_history,
  w_r_my_point,
  balance_pli,
  exchange_pli,
  lotto_price,
  send_transaction,
  send_transaction_tron , 
  send_transaction_w3p , 
  balance_all,
  w_l_popup,
  user_attend,
  staking_token,
  psite,
  event_add , 
  market_payed , 
  config 
}
